/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ScoringStrategy } from './ScoringStrategy';
import {
    ScoringStrategyFromJSON,
    ScoringStrategyFromJSONTyped,
    ScoringStrategyToJSON,
    ScoringStrategyToJSONTyped,
} from './ScoringStrategy';
import type { MatchScoringMode } from './MatchScoringMode';
import {
    MatchScoringModeFromJSON,
    MatchScoringModeFromJSONTyped,
    MatchScoringModeToJSON,
    MatchScoringModeToJSONTyped,
} from './MatchScoringMode';
import type { IScoringConfig } from './IScoringConfig';
import {
    IScoringConfigFromJSON,
    IScoringConfigFromJSONTyped,
    IScoringConfigToJSON,
    IScoringConfigToJSONTyped,
} from './IScoringConfig';
import type { IScoringResponseConfirmation } from './IScoringResponseConfirmation';
import {
    IScoringResponseConfirmationFromJSON,
    IScoringResponseConfirmationFromJSONTyped,
    IScoringResponseConfirmationToJSON,
    IScoringResponseConfirmationToJSONTyped,
} from './IScoringResponseConfirmation';

/**
 * 
 * @export
 * @interface IScoringResponse
 */
export interface IScoringResponse {
    /**
     * 
     * @type {MatchScoringMode}
     * @memberof IScoringResponse
     */
    mode: MatchScoringMode;
    /**
     * 
     * @type {ScoringStrategy}
     * @memberof IScoringResponse
     */
    strategy: ScoringStrategy;
    /**
     * Game ID for event pipeline (only for EVENT_PIPELINE/HYBRID modes)
     * @type {string}
     * @memberof IScoringResponse
     */
    gameId?: string;
    /**
     * 
     * @type {IScoringConfig}
     * @memberof IScoringResponse
     */
    config: IScoringConfig;
    /**
     * 
     * @type {IScoringResponseConfirmation}
     * @memberof IScoringResponse
     */
    confirmation: IScoringResponseConfirmation;
}



/**
 * Check if a given object implements the IScoringResponse interface.
 */
export function instanceOfIScoringResponse(value: object): value is IScoringResponse {
    if (!('mode' in value) || value['mode'] === undefined) return false;
    if (!('strategy' in value) || value['strategy'] === undefined) return false;
    if (!('config' in value) || value['config'] === undefined) return false;
    if (!('confirmation' in value) || value['confirmation'] === undefined) return false;
    return true;
}

export function IScoringResponseFromJSON(json: any): IScoringResponse {
    return IScoringResponseFromJSONTyped(json, false);
}

export function IScoringResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): IScoringResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'mode': MatchScoringModeFromJSON(json['mode']),
        'strategy': ScoringStrategyFromJSON(json['strategy']),
        'gameId': json['gameId'] == null ? undefined : json['gameId'],
        'config': IScoringConfigFromJSON(json['config']),
        'confirmation': IScoringResponseConfirmationFromJSON(json['confirmation']),
    };
}

export function IScoringResponseToJSON(json: any): IScoringResponse {
    return IScoringResponseToJSONTyped(json, false);
}

export function IScoringResponseToJSONTyped(value?: IScoringResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'mode': MatchScoringModeToJSON(value['mode']),
        'strategy': ScoringStrategyToJSON(value['strategy']),
        'gameId': value['gameId'],
        'config': IScoringConfigToJSON(value['config']),
        'confirmation': IScoringResponseConfirmationToJSON(value['confirmation']),
    };
}

